/**
 * định nghĩa title mã cha con dùng cho validate khi lưu MÃ con phải bắt đầu bằng mã cha
 * NXCHIEN 29.06.2022
 */
export default {
  di_account: {
    isCheckValidateChildCode: true, // có check mã con chứa mã cha
    // isCheckChildCodeSameLevel: true,
    parentKey: 'parent_number',
    mesChild: 'Số hiệu tài khoản',
    mesParent: 'Số tài khoản tổng hợp',
    mesGroup: 'số tài khoản tổng hợp và nhóm tài khoản',
  },
  di_budget_source: {
    isCheckValidateChildCode: true, // có check mã con chứa mã cha
    mesChild: 'nguồn kinh phí',
    mesParent: 'Nguồn kinh phí',
    parentKey: 'parent_code',
  },
  di_task: {
    isCheckValidateChildCode: true, // có check mã con chứa mã cha
    parentKey: 'parent_code',
    mesChild: 'nhiệm vụ',
    mesParent: 'Nhiệm vụ',
  },
};
